import { inject, Injectable, signal } from '@angular/core';
import { CacheThemeOptions } from 'src/app/interfaces/cache-theme-options';
import { CustomerTheme } from 'src/app/interfaces/customer-theme';
import { CustomerThemeProviderService } from 'src/app/providers/customer-theme/customer-theme.provider.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerThemeService {
  private customerThemeProvider = inject(CustomerThemeProviderService);

  theme = signal<CustomerTheme | null>(null);

  async cacheTheme({ ringBuilderID, iframeID }: CacheThemeOptions) {
    if (iframeID) {
      await this.cacheThemeWithIframeID(iframeID);
    } else if (ringBuilderID) {
      await this.cacheThemeWithRingBuilderID(ringBuilderID);
    }
  }

  private async cacheThemeWithRingBuilderID(ringBuilderID: string) {
    this.theme.set(await this.customerThemeProvider.getWithRingBuilderID(ringBuilderID));
  }

  private async cacheThemeWithIframeID(iframeID: string) {
    this.theme.set(await this.customerThemeProvider.getWithIframeID(iframeID));
  }
}
